import React, { useEffect, useState } from "react";
import { MinimalContainerPadding } from "../../styles/Theme";
import SamplesResults from "../sample_testing/SamplesResults";
import Samples from "../sample_reporting/Samples";
import Button from "../Button";
import moment from "moment";
import Checkbox from "../common/form/Checkbox";
import { fetchSamples } from "../sample_reporting/Utils/SamplesFetch";

export default function SamplesAwaitingNotification({ result_notification_group_id }) {
  const [viewDetails, setViewDetails] = useState({
    view: null,
    generation: 1,
    requiresAuthorisation: false
  });
  const [startDate, setStartDate] = useState(moment().subtract(365, "days"));
  const [endDate, setEndDate] = useState(moment());
  const [sampleList, setSampleList] = useState(null);

  const view = viewDetails.view;
  const generation = viewDetails.generation;
  const requiresAuthorisation = viewDetails.requiresAuthorisation;

  const updateView = (viewName, needsAuthorisation) => {
    if (view === viewName && requiresAuthorisation === needsAuthorisation) {
      setSampleList(null);
      setViewDetails({
        view: null,
        generation: viewDetails.generation + 1,
        requiresAuthorisation
      });
    } else {
      setViewDetails({
        generation: viewDetails.generation + 1,
        view: viewName,
        requiresAuthorisation: needsAuthorisation
      });
    }
  };

  const resultSearchParams = {
    awaiting_notification: true,
    start_date: startDate ? startDate.format("YYYY-MM-DD") : null,
    end_date: endDate ? endDate.format("YYYY-MM-DD") : null,
    requires_notification_authorisation: requiresAuthorisation,
    result_notification_group_id
  };

  const sampleSearchParams = {
    awaiting_notification: true,
    start_date: startDate,
    end_date: moment(),
    requires_notification_authorisation: requiresAuthorisation,
    result_notification_group_id
  };

  useEffect(() => {
    if (view !== "samples") return;

    setSampleList(null);
    fetchSamples(sampleSearchParams).then(sl => setSampleList(sl));
  }, [generation]);

  return (
    <MinimalContainerPadding>
      <div>
        <Button
          title={"All Samples"}
          tiny
          highlight={view == "samples" && !requiresAuthorisation}
          onClick={() => updateView("samples", false)}
        />
        <span style={{ marginRight: 10 }}>&nbsp;</span>
        <Button
          title={"Samples Requiring Authorisation"}
          tiny
          highlight={view == "samples" && requiresAuthorisation}
          onClick={() => updateView("samples", true)}
        />
        <span style={{ marginRight: 10 }}>&nbsp;</span>
        <Button
          title={"All Results"}
          tiny
          highlight={view == "results" && !requiresAuthorisation}
          onClick={() => updateView("results", false)}
        />
        <span style={{ marginRight: 10 }}>&nbsp;</span>
        <Button
          title={"Results Requiring Authorisation"}
          tiny
          highlight={view == "results" && requiresAuthorisation}
          onClick={() => updateView("results", true)}
        />
      </div>

      {view == "results" && (
        <div style={{ marginTop: 20 }}>
          <SamplesResults
            key={generation}
            searchParams={resultSearchParams}
            initialSimpleSampleView={true}
            clientView={false}
          />
        </div>
      )}
      {view == "samples" && !sampleList && (
        <div style={{ paddingTop: 10 }}>
          <i className="fa fa-spinner fa-spin" />
        </div>
      )}
      {view == "samples" && sampleList && (
        <div style={{ marginTop: 20 }}>
          <Samples
            view="sample_notifications"
            key={generation}
            sample_list={sampleList}
            showAttributes={false}
            clientView={false}
          />
        </div>
      )}
    </MinimalContainerPadding>
  );
}
